const enum LocalStorageKeys {
  PURCHASE_ORDER_DASH_SETTINGS = "HealfopsPurchaseOrdersDashSettingsV4",
  TRANSIT_PURCHASE_ORDER_DASH_SETTINGS = "HealfopsTransitPurchaseOrdersDashSettingsV1",
  WAREHOUSE_CHECK_IN_DASH_SETTINGS = "HealfopsWarehouseCheckInsDashSettingsV4",
  USER_ACCOUNTS_DASH_SETTINGS = "HealfopsUserAccountsDashSettingsV2",
  VENDOR_ACCOUNTS_DASH_SETTINGS = "HealfopsVendorAccountsDashSettingsV2",
  UOM_SETTINGS = "HealfopsUoMSettingsV2",
  CLAIM_DASH_SETTINGS = "HealfopsClaimsDashSettingsV1",
  PO_BARCODE_LOOKUP_SETTINGS = "HealfopsPOBarcodeLookupSettingsV1",
  TRANSFER_ORDER_DASH_SETTINGS = "HealfopsTransferOrdersDashSettingsV1",
  ACTIVE_ANTS_PURCHASE_ORDER_DASH_SETTINGS = "HealfopsActiveAntsPurchaseOrdersDashSettingsV1",
  SHIPMENT_JOBS_IN_FLIGHT = "HealfopsShipmentJobsInFlightV1"
}

export { LocalStorageKeys };
